import React, { useState, useEffect } from "react";
import axios from "axios";
import { parseISO, format } from "date-fns";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { toast } from "react-toastify";
import { BlackListModal } from "./components/BlackListModal";
import { BlackList } from "./components/BlackList";

const ResponsiveModal = styled(Modal)`
  .modal-body {
    padding: 40px !important;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .modal-content {
    border-radius: 10px !important;
    max-height: 90vh;
  }

  .modal-dialog {
    max-width: 700px !important;
  }

  @media screen and (max-width: 767px) {
    .modal-content {
      width: 90% !important;
      margin: 0 auto !important;
    }
  }
`;

const ButtonBack = styled.img`
  filter: brightness(0) saturate(100%) invert(58%) sepia(59%) saturate(452%)
    hue-rotate(103deg) brightness(92%) contrast(83%);
  cursor: pointer;
  margin: 0 5px 5px 0;
`;

export function Consultas() {
  const [modalLogsOpen, setModalLogsOpen] = useState(false);
  const [logs, setLogs] = useState({});
  const [data, setData] = useState([]);
  const [isBlackList, setIsBlackList] = useState(false);
  const [blackListData, setBlackListData] = useState([]);
  const [isOperating, setIsOperating] = useState(false);
  const [isCreateBlackListModalOpen, setIsCreateBlackListModalOpen] = useState(
    false
  );
  const [needRefetch, setNeedRefetch] = useState(false);
  const getConsultas = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/queries/list_error_queries"
    );
    setData(response.data.data);
  };
  const getBlackList = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/black_list_document"
    );
    setBlackListData(response.data.data);
  };

  useEffect(() => {
    getConsultas();
    getBlackList();
  }, []);

  const openLogs = query => {
    setLogs({
      query_response: query.query_response,
      query_response_plain: query.query_response
    });
    setModalLogsOpen(true);
  };

  const whatsapp = phone => {
    const phoneOnlyNumbers = phone
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "");
    const phoneInternational = `55${phoneOnlyNumbers}`;

    window.open(
      `https://api.whatsapp.com/send?phone=${phoneInternational}&text=`,
      "_blank"
    );
  };
  const handleOpenAttachment = url => {
    window.open(url, "_blank", "noopener noreferrer");
  };

  const handleDeleteDocument = async id => {
    if (!window.confirm("Tem certeza que deseja excluir este documento?"))
      return;

    try {
      setIsOperating(true);

      await axios.delete(
        `${process.env.REACT_APP_API_URL}/black_list_document/${id}`
      );

      setBlackListData(prevData => prevData.filter(item => item.id !== id));
    } catch (error) {
      toast.error("Erro ao excluir documento");
    } finally {
      setIsOperating(false);
    }
  };

  const handleActivateDocument = async (id, active) => {
    try {
      setIsOperating(true);

      await axios.patch(
        `${process.env.REACT_APP_API_URL}/black_list_document/${id}`,
        { active: !active }
      );

      setBlackListData(prevData =>
        prevData.map(item =>
          item.id === id ? { ...item, active: !active } : item
        )
      );
      toast.success("Sucesso ao alterar status do documento");
    } catch (error) {
      toast.error("Erro ao ativar/inativar documento");
    } finally {
      setIsOperating(false);
    }
  };

  useEffect(() => {
    if (needRefetch) {
      getBlackList();
      setNeedRefetch(false);
    }
  }, [needRefetch]);

  return (
    <>
      <ResponsiveModal
        show={modalLogsOpen}
        onHide={() => setModalLogsOpen(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <ButtonBack
            onClick={() => setModalLogsOpen(false)}
            src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-left.svg")}
          />
          <h3>Response:</h3>
          {logs && logs.query_response && (
            <div>
              <pre>{JSON.stringify(logs.query_response, null, 2)}</pre>
            </div>
          )}
          <h3>Plain:</h3>
          {logs && logs.query_response_plain && (
            <div>
              <pre>{JSON.stringify(logs.query_response_plain, null, 2)}</pre>
            </div>
          )}
        </Modal.Body>
      </ResponsiveModal>
      <BlackListModal
        isCreateBlackListModalOpen={isCreateBlackListModalOpen}
        setIsCreateBlackListModalOpen={setIsCreateBlackListModalOpen}
        getBlackList={getBlackList}
        setNeedRefetch={setNeedRefetch}
        needRefetch={needRefetch}
      />
      <h1 className="azul-cabecalho">CONSULTAS</h1>
      <p className="subheader-text mb-10">Consultas Jusfinder</p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "10px"
        }}
      >
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => setIsBlackList(!isBlackList)}
        >
          Ir para {isBlackList ? "consultas" : "blacklist de documentos"}
        </button>
        {isBlackList && (
          <button
            className="btn btn-primary"
            onClick={() => setIsCreateBlackListModalOpen(true)}
          >
            Criar documento na blacklist
          </button>
        )}
      </div>
      {!isBlackList && (
        <div className="row mb-10">
          <div className="col-xl-12">
            <div
              style={{
                backgroundColor: "#fff",
                border: "1px solid #eaeaea",
                borderRadius: "5px",
                padding: "20px"
              }}
            >
              <div className="row mb-5">
                <h3>Consultas com erro</h3>
                <table className="table table-bordered table-striped table-sm">
                  <thead className="light">
                    <tr>
                      <th>Consultado em</th>
                      <th>Cliente</th>
                      <th>E-mail</th>
                      <th>Telefone</th>
                      <th>Documento Consultado</th>
                      <th>Tipo da consulta</th>
                      <th>Pagamento?</th>
                      <th>Logs</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map(query => (
                        <tr>
                          <td>
                            {format(
                              parseISO(query.created_at),
                              "dd/MM/yyyy HH:mm"
                            )}
                          </td>
                          <td>{query.name}</td>
                          <td>{query.email}</td>
                          <td>
                            <a
                              href="javascript:;"
                              onClick={() => whatsapp(query.phone)}
                            >
                              {query.phone}
                            </a>
                          </td>
                          <td>{query.document}</td>
                          <td>{query.query_type}</td>
                          <td>
                            {query.payment_id == null ? "Não" : "Sim"}{" "}
                            {!query.status ? "" : " - " + query.status}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-primary"
                              onClick={() => openLogs(query)}
                            >
                              <i className="flaticon-eye"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {isBlackList && (
        <BlackList
          blackListData={blackListData}
          handleOpenAttachment={handleOpenAttachment}
          handleActivateDocument={handleActivateDocument}
          handleDeleteDocument={handleDeleteDocument}
          isOperating={isOperating}
        />
      )}
    </>
  );
}
